import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useMe, useLogout } from '../hooks/useAuth';
import { useProgress } from '../hooks/useProgress';
import { lessons } from '../lessons';

export default function AppShell() {
  const { data: me } = useMe();
  const logout = useLogout();
  const { data: progress } = useProgress(!!me);
  const completed = new Set(progress?.completed ?? []);
  const location = useLocation();

  const pct = Math.round((completed.size / lessons.length) * 100);

  return (
    <>
      <header className="top">
        <div className="user-strip">
          <span>Hola, {me?.displayName || me?.email}</span>
          <button onClick={() => logout.mutate()} disabled={logout.isPending}>Cerrar sesión</button>
        </div>
        <div className="badges">
          <span className="badge">10 sesiones</span>
          <span className="badge">3 horas por sesión</span>
          <span className="badge">Edad orientativa: 12+</span>
          <span className="badge">Arduino + robótica</span>
        </div>
        <h1>ROOM-E</h1>
        <p>Curso práctico de verano para construir un robot útil. Cada día incluye teoría adaptada, montaje, código comentado, ejercicios, reto, comprobación y un resultado que funciona.</p>
        <div className="progress-shell"><div style={{ width: `${pct}%` }} /></div>
        <div className="progress-text">{completed.size} de {lessons.length} sesiones completadas</div>
      </header>

      <div className="layout">
        <aside>
          {lessons.map((l) => (
            <NavLink
              key={l.slug}
              to={`/lessons/${l.slug}`}
              className={({ isActive }) =>
                [isActive ? 'active' : '', completed.has(l.slug) ? 'done' : ''].join(' ')
              }
            >
              <span>{l.order}</span>
              {l.title.replace(/^Día \d+ · /, '')}
            </NavLink>
          ))}
          {location.pathname !== '/dashboard' && (
            <Link to="/dashboard" style={{ display: 'block', marginTop: 10, textAlign: 'center', color: '#5a6c81', textDecoration: 'none', fontSize: '.9rem' }}>Resumen ↗</Link>
          )}
        </aside>
        <main>
          <Outlet />
        </main>
      </div>

      <section className="sources">
        <h3>Documentación de referencia</h3>
        <ul>
          <li><a href="https://eu.elegoo.com/en-ie/products/elegoo-uno-project-super-starter-kit" target="_blank" rel="noopener noreferrer">ELEGOO UNO R3 Super Starter Kit</a></li>
          <li><a href="https://eu.elegoo.com/es-pt/blogs/arduino-projects/elegoo-smart-robot-car-kit-v3-0-plus-v3-0-v2-0-tutorial" target="_blank" rel="noopener noreferrer">Tutorial oficial ELEGOO Smart Robot Car Kit V3.0</a></li>
          <li><a href="https://docs.arduino.cc/language-reference/" target="_blank" rel="noopener noreferrer">Referencia del lenguaje Arduino</a></li>
        </ul>
      </section>
    </>
  );
}
